// extracted by mini-css-extract-plugin
export default {"landingPageButton":"LandingPageButton_landingPageButton__md5WN","primary":"LandingPageButton_primary__rdSbD","secondary":"LandingPageButton_secondary__-34Mm"};